import { Component, OnInit } from '@angular/core';
import {ApplicationToolbarActions} from "../../Redux/Actions/application-toolbar-actions";
import {NavigationEnd, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {select} from "@angular-redux/store";
import {isNullOrUndefined} from "util";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MessageDlgComponent} from "../nav-catalog/message-dlg/message-dlg.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'edsng-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
// @select(["appUserInfo", "user"]) user$;
  // userLogged = false;

  public showToolbar = false;

  constructor(private dialog: MatDialog, private router: Router,  private snack: MatSnackBar,  private act: ActionsService, public translate: TranslateService ) {
    // this.user$.subscribe(x => {
    //   this.userLogged = !isNullOrUndefined(x);
    // });
  }

  ngOnInit() {
    this.showToolbar = !window.location.hash.includes("hackathon");
  }

  /**
   * Funzione che viene richiamata per aprire/chiudere la sidebar
   */
  manageSidebar() {
    this.act.sendAction(ApplicationToolbarActions.switchSideBar());
  }
  closeSidebar() {
    this.act.sendAction(ApplicationToolbarActions.setSideBarOpened(false));
  }

  showDashboard() {
    // if ( this.userLogged ) {
      this.router.navigate(["/dashboard"]);
      this.closeSidebar();
    // } else {
    //   this.messageRequestLogin();
    // }
  }

  // messageRequestLogin() {
  //   const config = new MatDialogConfig();
  //   config.disableClose = true;
  //   const dialogRef = this.dialog.open(MessageDlgComponent, config);
  //   dialogRef.componentInstance.icon = "info";
  //   dialogRef.componentInstance.title = this.translate.instant('COMMON.errors.signIn required title');
  //   dialogRef.componentInstance.cancelButton = null;
  //   dialogRef.componentInstance.message = this.translate.instant('COMMON.errors.signIn required dashboard msg');
  // }

  showHelp() {
    this.router.navigate(["/help"]);
    this.closeSidebar();
  }
}
